import http from "../../../core/services/http.service";

const SalesTaxConfigurationService = {
  getStatesByCountryCode(params = null) {
    return http.get(`/api/v1/geographic-structure/states/`, {params});
  },
  getCounties(params = null, expand = 'num_cities') {
    return http.get(`/api/v1/geographic-structure/counties/?expand=${expand}`, {params});
  },
  getCities(params = null, expand = '') {
    return http.get(`/api/v1/geographic-structure/cities/?expand=${expand}`, {params});
  },
  createState(params = null) {
    return http.post(`/api/v1/geographic-structure/states/`, params);
  },
  updateState(params = null, expand = 'counties.cities') {
    return http.put(`/api/v1/geographic-structure/states/${params.uuid}/?expand=${expand}`, params);
  },
  deleteState(uuid) {
    return http.delete(`/api/v1/geographic-structure/states/${uuid}`);
  },
  createCounty(params = null) {
    return http.post(`/api/v1/geographic-structure/counties/`, params);
  },
  updateCounty(params = null, expand = 'counties.cities') {
    return http.put(`/api/v1/geographic-structure/counties/${params.uuid}/?expand=${expand}`, params);
  },
  deleteCounty(uuid) {
    return http.delete(`/api/v1/geographic-structure/counties/${uuid}`);
  },
  createCity(params = null) {
    return http.post(`/api/v1/geographic-structure/cities/`, params);
  },
  updateCity(params = null, expand = 'counties.cities') {
    return http.put(`/api/v1/geographic-structure/cities/${params.uuid}/?expand=${expand}`, params);
  },
  deleteCity(uuid) {
    return http.delete(`/api/v1/geographic-structure/cities/${uuid}`);
  },
  changeThresholdStatus(params) {
    return http.put(`/api/v1/geographic-structure/batch-update-nexus-threshold-status/`, params);
  },
}

export default SalesTaxConfigurationService;

